var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.iterations.length > 0
    ? _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "mx-auto" },
          _vm._l(_vm.iterations, function(iteration) {
            return _c(
              "button",
              {
                staticClass:
                  "btn btn-sm btn-outline-dark ml-1 mb-1 btn-display-iteration",
                class: [
                  iteration.Id == _vm.taskDataId ? "disabled" : "",
                  iteration.Progress.cssClass
                ],
                attrs: { title: _vm.getTitle(iteration) },
                on: {
                  click: function($event) {
                    return _vm.openTask(iteration)
                  }
                }
              },
              [
                _c("strong", [_vm._v(_vm._s(iteration.Iteration))]),
                _vm._v(
                  "\n            -\n            " +
                    _vm._s(_vm._f("date-format")(iteration.Created)) +
                    "\n\n            "
                ),
                _c("i", {
                  staticClass: "status-icon fa",
                  class: iteration.Progress.iconCssClass
                })
              ]
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dd6f99a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dd6f99a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Output/Iterations.vue
// module id = 591
// module chunks = 0